import { render, staticRenderFns } from "./SubGroupView.vue?vue&type=template&id=38664fb2&"
import script from "./SubGroupView.vue?vue&type=script&lang=js&"
export * from "./SubGroupView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports